/**
 * Display copy for the login screen. Extracted verbatim from
 * app/(auth)/login/page.tsx (OPL-4289) — every string is unchanged.
 */

/** Get button label for the unlock button */
export function getUnlockButtonLabel(
	isLoading: boolean,
	oauthClient: { clientName: string } | null
): string {
	if (isLoading) {
		return "Unlocking...";
	}
	if (oauthClient) {
		return "Continue";
	}
	return "Unlock";
}

/** Get subtitle text for the password section */
export function getPasswordSubtitle(
	oauthClient: { clientName: string } | null
): string {
	if (oauthClient) {
		return `Enter your password to authorize ${oauthClient.clientName}`;
	}
	return "Enter your backup password.";
}

/** Resolve heading copy for the sign-in options view */
export function getSignInOptionsHeading(
	oauthClient: { clientName: string } | null,
	isAlternativeSignIn: boolean
): { title: string; subtitle: string } {
	if (oauthClient) {
		return {
			title: "Choose how to sign in",
			subtitle: `Sign in to authorize ${oauthClient.clientName}`,
		};
	}
	if (isAlternativeSignIn) {
		return {
			title: "Choose how to sign in",
			subtitle:
				"Use an account linked to your Sigma ID, or import your backup file",
		};
	}
	return {
		title: "Sign in",
		subtitle: "Use your wallet, your backup file, or a linked account.",
	};
}
